/**
 * Map domain state → Badge variant. Single source of truth so the list
 * and detail pages render the same tone for the same status. Variants
 * are theme-aware (defined in components/ui/badge.tsx via CSS tokens).
 */
import type { InboundPaymentState, IntentState, ProviderTxStatus } from "@/lib/api";
import type { BadgeProps } from "@/components/ui/badge";

export const INTENT_STATE_BADGE_VARIANT: Record<IntentState, BadgeProps["variant"]> = {
  requires_action: "warning",
  processing: "info",
  succeeded: "success",
  failed: "destructive",
  cancelled: "muted",
  refunding: "info",
  refunded: "secondary",
};

export const INBOUND_STATE_BADGE_VARIANT: Record<InboundPaymentState, BadgeProps["variant"]> = {
  received: "success",
  reversed: "destructive",
};

export const PROVIDER_TX_STATUS_VARIANT: Record<ProviderTxStatus, BadgeProps["variant"]> = {
  pending: "warning",
  succeeded: "success",
  failed: "destructive",
  unknown: "warning",
};
